module.exports = __webpack_public_path__ + "static/img/sangwenfeng.1df0b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/sangwenfeng.png
// module id = qEZf
// module chunks = 0